import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/AiInnovation.css';

const AiInnovation: React.FC = () => {
  const navigate = useNavigate();
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Services/AI Innovation & Academic Modernization/ai-innovation-academic-modernization-banner-image.png`;
  
  return (
    <div className="ai-innovation-page">
      <div className="ai-hero-banner">
        <div 
          className="ai-hero-background"
          style={{ 
            backgroundImage: `url("${imagePath}")` 
          }}
        ></div>
        <div className="ai-hero-content">
          <p className="ai-hero-breadcrumb">Our Services / AI Innovation & Academic Modernization</p>
          <h1 className="ai-hero-title">AI Innovation & Academic Modernization Services</h1>
        </div>
      </div>

      <div className="ai-innovation-body">
        <div className="ai-innovation-intro">
          <p>
            Myers McRae helps colleges and universities future-proof their operations and academics by integrating <strong>Artificial Intelligence</strong> across two critical fronts: broad institutional modernization and specialized, high-impact research.
          </p>
          <p>
            Our services ensure your institution remains competitive, drives students to success, and leads the way in critical applied research fields like healthcare AI.
          </p>
        </div>
      </div>

      <div className="ai-text-image-pair">
        <div className="ai-image-left-text-right">
          <div className="ai-image-left">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Services/AI Innovation & Academic Modernization/academic-modernization-section-image.png`}
              alt="Academic Modernization"
            />
          </div>
          <div className="ai-text-right">
            <h2 className="ai-text-right-title">Academic Modernization & Applied AI Education</h2>
            <p className="ai-text-right-intro">
              This service is designed to rapidly integrate AI curriculum and tools into your campus, ensuring students and faculty are equipped with essential AI literacy and practical application skills.<br></br>
              <b>Stay ahead of the curve with AI curriculum and applied student experiences:</b>
            </p>
            
            <h3 className="ai-text-right-heading">Core Educational Initiatives:</h3>
            <ul className="ai-text-right-list">
              <li><b>AI Lab-in-a-Box:</b> Rapidly launch or expand your AI offerings with a complete solution that includes modular, ready-to-use curriculum and essential software/tools for hands-on student projects.</li>
              <li><b>AI Career Bootcamps & Workshops:</b> Equip students and faculty with focused training designed to build immediate, employable skills through intensive career bootcamps and workshops on AI principles and ethical application.</li>
              <li><b>Real-World Application Case Studies:</b> Deepen student learning by collaborating on real-world application case studies where students use AI tools to solve operational or research problems on campus.</li>
            </ul>
            <p className="ai-text-right-goal">
              <strong>Goal:</strong> Enhance effectiveness, agility, and institutional impact by aligning goals across departments and focusing resources on high-impact, future-ready areas.
            </p>
          </div>
        </div>

        <div className="ai-image-right-text-left">
          <div className="ai-text-left">
            <h2 className="ai-text-left-title">Specialized Initiative: Healthcare AI Imaging Labs</h2>
            <p className="ai-text-left-intro">
              Through a joint venture with Radiant Sage, we're establishing AI Medical Imaging Labs in partnership with universities and healthcare research institutions. This initiative provides a pathway for institutions—even those without medical schools or patient data—to become major players in the healthcare AI ecosystem.
            </p>
            <p className="ai-text-left-intro">
              By leveraging Radiant Sage's infrastructure and regulatory expertise, faculty and students can engage in industry-funded, life-changing research while accelerating real-world applications of AI in medicine.
            </p>
            <h3 className="ai-text-left-heading">The Lab Initiative is Designed to:</h3>
            <ul className="ai-text-left-list">
              <li><b>Advance AI-Driven Research:</b> Facilitate AI-driven medical imaging research and innovation using specialized tools and expert guidance.</li>
              <li><b>Provide Data Access:</b> Enable access to anonymized, regulatory-ready imaging datasets from Radiant Sage's global clinical trial network, overcoming the most significant hurdle in medical AI research.</li>
              <li><b>Create Commercial Pathways:</b> Establish commercialization pathways for university-led innovation through tech transfer, licensing, and industry partnerships.</li>
            </ul>
          </div>
          <div className="ai-image-right">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Services/AI Innovation & Academic Modernization/specialized-initiative-section-image.png`}
              alt="Healthcare AI Imaging Labs"
            />
          </div>
        </div>
      </div>

      <div className="ai-contact-us">
        <h2 className="ai-contact-us-title">Partner with Myers McRae</h2>
        <p className="ai-contact-us-description">
          Whether you need to modernize your academic offerings across the board or launch a specialized, commercial-ready research center, Myers McRae provides the strategic insight and practical tools to secure your position as a leader in <strong>applied AI and innovation</strong>.
        </p>
        <p className="ai-contact-us-description">
          If your institution is looking to expand its leadership in applied research, STEM innovation, and industry collaboration, we invite you to explore an <strong>AI Imaging Lab pilot partnership</strong>.
        </p>
        <div className="ai-contact-us-buttons">
          <button 
            className="ai-contact-us-button ai-contact-us-button-primary"
            onClick={() => {
              navigate('/contact-us');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Contact us to explore an AI Imaging Lab pilot partnership
          </button>
          <button 
            className="ai-contact-us-button ai-contact-us-button-secondary"
            onClick={() => {
              navigate('/contact-us');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Contact us about our Academic Modernization approach
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiInnovation;

